const CALL_STATES = {
    IDLE : 'idle',
    DIALING : 'dialing',
    RINGING : 'ringing',
    IN_CALL : 'active',
    ENDED : 'ended',
};

const SUB_BUTTON_ACTIONS = {
    MUTE : 'mute',
    HOLD : 'hold',
    END : 'end',
};

export {
    CALL_STATES,
    SUB_BUTTON_ACTIONS
}